export default "__VITE_ASSET__Vfchsdn$__"